var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../../element-factory";
import { SurveyElementBase } from "../../reactquestion_element";
import { SurveyAction } from "./action-bar-item";
export * from "./action-bar-item-dropdown";
export * from "./action-bar-separator";
var SurveyActionBar = /** @class */ (function (_super) {
    __extends(SurveyActionBar, _super);
    function SurveyActionBar(props) {
        var _this = _super.call(this, props) || this;
        _this.rootRef = React.createRef();
        return _this;
    }
    Object.defineProperty(SurveyActionBar.prototype, "handleClick", {
        get: function () {
            return this.props.handleClick !== undefined ? this.props.handleClick : true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyActionBar.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    SurveyActionBar.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (!this.model.hasVisibleActions)
            return;
        var container = this.rootRef.current;
        if (!!container) {
            this.model.initResponsivityManager(container, function (callback) { setTimeout(callback, 100); });
        }
    };
    SurveyActionBar.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.model.resetResponsivityManager();
    };
    SurveyActionBar.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        if (prevProps.model != this.props.model) {
            prevProps.model.resetResponsivityManager();
        }
        if (!!this.model.hasVisibleActions) {
            var container = this.rootRef.current;
            if (!!container) {
                this.model.initResponsivityManager(container, function (callback) { setTimeout(callback, 100); });
            }
        }
    };
    SurveyActionBar.prototype.getStateElement = function () {
        return this.model;
    };
    SurveyActionBar.prototype.renderElement = function () {
        if (!this.model.hasActions)
            return null;
        var items = this.renderItems();
        return (React.createElement("div", { ref: this.rootRef, style: this.model.getRootStyle(), className: this.model.getRootCss(), onClick: this.handleClick ? function (event) {
                event.stopPropagation();
            } : undefined }, items));
    };
    SurveyActionBar.prototype.renderItems = function () {
        return this.model.renderedActions.concat([]).map(function (item, itemIndex) {
            return (React.createElement(SurveyAction, { item: item, key: item.renderedId }));
        });
    };
    return SurveyActionBar;
}(SurveyElementBase));
export { SurveyActionBar };
ReactElementFactory.Instance.registerElement("sv-action-bar", function (props) {
    return React.createElement(SurveyActionBar, props);
});
